import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  async getById(Redis = false, reset = false, id) {
    if (!String(id ?? "").trim()) {
      return null;
    }
    const data = await redisGetHandler(
      Redis,
      axios,
      config.SERVICE_DATABASE_API_URL,
      `/images/${String(id).trim()}`,
      reset,
    );
    return data && typeof data === "object" ? data : null;
  },

  /**
   * POST: попросить бэкенд сгенерировать уменьшенную копию изображения.
   * Бэкенд скачает оригинал, сожмёт его в webp нужного размера и положит
   * рядом под именем `${width}_${height}.webp`. Идемпотентно.
   * Вызывается из Next API-роута `/api/images/resize` (server-side).
   */
  async resize({ id, width, height, fit = "inside", reset = false }) {
    const response = await axios.post(
      `${config.SERVICE_DATABASE_API_URL}/images/resize`,
      { id, width, height, fit, reset },
    );
    return response?.data ?? null;
  },
});
